export const header = {
    dictionary: "Dictionary",
    writeReviews: "Write Reviews",
    timetable: "Timetable",
    planner: "Planner",
    syllabus: "Syllabus",
    changeTheme: "Change theme",
    openMenu: "Open menu",
    navigationMenu: "Main menu",
}
